/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.5.11",
    versionName: "0.2.0-nightly.2026.5.11",
    versionChannel: "nightly",
    buildDate: "2026-05-11T00:32:19.690Z",
    commitHash: "2b5ad681535ff0ebb19bafad8b21c2f495f8718e",
};
